import type { LucideIcon } from 'lucide-react'
import styled from 'styled-components'

export const FORM_LABEL_GRADIENT_ID = 'form-label-gradient'

export function FormGradientDefs() {
  return (
    <svg aria-hidden width="0" height="0" style={{ position: 'absolute' }}>
      <defs>
        <linearGradient id={FORM_LABEL_GRADIENT_ID} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#ffc951" />
          <stop offset="100%" stopColor="#c94daa" />
        </linearGradient>
      </defs>
    </svg>
  )
}

const IconWrap = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  line-height: 0;
`

type FormLabelIconProps = {
  icon: LucideIcon
  size?: number
}

export function FormLabelIcon({ icon: Icon, size = 14 }: FormLabelIconProps) {
  return (
    <IconWrap aria-hidden>
      <Icon
        size={size}
        stroke={`url(#${FORM_LABEL_GRADIENT_ID})`}
        strokeWidth={2.25}
      />
    </IconWrap>
  )
}
